import "./index.scss"
import { SignUpForm } from "./sign_up_form.js"

// The SignUpForm connected to each sign-up form element, so it can be
// disconnected when Turbo takes the form off the page.
const signUpForms = new WeakMap()

// The sign-up page's script is plain JavaScript, not a Stimulus controller, so
// this module exports no Controller. Turbo fires turbo:load on the first page
// load as well as after each Turbo visit.
document.addEventListener("turbo:load", () => {
  for (const element of document.querySelectorAll("#church_account_form:not([data-sign-up-ready])")) {
    const signUpForm = new SignUpForm(element)
    signUpForm.connect()
    signUpForms.set(element, signUpForm)
    element.setAttribute("data-sign-up-ready", "")
  }
})

// On Back and Forward, Turbo shows a copy of the page it kept, without the
// listeners. The copy must not look ready, so turbo:load connects it again.
// The form it is copied from is leaving the page, so it is disconnected.
document.addEventListener("turbo:before-cache", () => {
  for (const element of document.querySelectorAll("#church_account_form[data-sign-up-ready]")) {
    signUpForms.get(element)?.disconnect()
    signUpForms.delete(element)
    element.removeAttribute("data-sign-up-ready")
  }
})
